//utils
import {
    getPayLaterHttpOptions,
    transformCheckPayLaterApiResponse,
    transformCreditLimitApiResponse,
} from "@payment-client/utils/PublicPayLaterUtils";
import { HTTP_METHODS, makeDownstreamApiCall } from "@swiggy-private/checkout-core";

//interfaces
import { ApiResponse } from "@payment-client/interfaces/Api";
import { LinkablePayLater } from "@payment-client/interfaces/WalletPublic";
import { PayLaterResponse, Response, CreditLimitBusinessError } from "@payment-client/interfaces/PublicPayLater";
import { PayLaterCreditLimitData, PayLaterLinkedData } from "@swiggy-private/payment-ui";

export async function checkPayLaterLinkStatusPublic(
    apiHost: string,
    payLaterCode: string,
    amount?: string,
): Promise<PayLaterLinkedData> {
    const httpOptionsResult = getPayLaterHttpOptions(payLaterCode as LinkablePayLater, "isLinked", HTTP_METHODS.GET);

    const { endpoint, method } = httpOptionsResult.unwrap();

    const data = await makeDownstreamApiCall({
        apiHost,
        endpoint,
        searchParams: { amount: amount || "" },
        options: {
            method,
        },
    });

    const response = transformCheckPayLaterApiResponse(data as Response<PayLaterResponse>);
    return response?.data as PayLaterLinkedData;
}

export async function linkPayLaterPublic(
    apiHost: string,
    payLaterCode: string,
    mobileNumber: string,
): Promise<ApiResponse> {
    const httpOptionsResult = getPayLaterHttpOptions(payLaterCode as LinkablePayLater, "link", HTTP_METHODS.POST);

    const { endpoint, method } = httpOptionsResult.unwrap();

    const response = await makeDownstreamApiCall({
        apiHost,
        endpoint,
        bodyParams: { mobileNumber },
        options: {
            method,
        },
    });

    return response?.data as ApiResponse;
}

export async function validatePayLaterOtpPublic(
    apiHost: string,
    params: { payLaterCode: string; otp: string; state?: object },
): Promise<ApiResponse> {
    const { payLaterCode, otp, state = {} } = params;

    const httpOptionsResult = getPayLaterHttpOptions(
        payLaterCode as LinkablePayLater,
        "validateOtp",
        HTTP_METHODS.POST,
    );

    const { endpoint, method } = httpOptionsResult.unwrap();

    const response = await makeDownstreamApiCall({
        apiHost,
        endpoint,
        bodyParams: { otp, ...state },
        options: {
            method,
        },
    });

    return response as ApiResponse;
}

export async function getPaylaterCreditLimit(
    apiHost: string,
    payLaterCode: string,
    amount: string,
): Promise<PayLaterCreditLimitData | CreditLimitBusinessError | null> {
    const httpOptionsResult = getPayLaterHttpOptions(payLaterCode as LinkablePayLater, "creditLimit", HTTP_METHODS.GET);

    const { endpoint, method } = httpOptionsResult.unwrap();

    const response = await makeDownstreamApiCall({
        apiHost,
        endpoint,
        searchParams: {
            paymentInstrument: payLaterCode,
            amount,
        },
        options: {
            method,
        },
    });

    return transformCreditLimitApiResponse(response as Response);
}
